module.exports = __webpack_public_path__ + "b.no1.adfa734a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/b.no1.jpg
// module id = ZfB0
// module chunks = 0